import React from 'react'

import { Text } from './Text'
import Center from '../helpers/Center'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'

const IconText = ({ label, left, Icon: PropIcon, icon, iconName, color, iconSize, gutter, ...props }) => {
  icon = PropIcon ? <PropIcon style={{ color }} /> : icon
  if (iconName)
    icon = (
      <FlexCol>
        <Center>
          <Icon name={iconName} color={color} size={iconSize} />
        </Center>
      </FlexCol>
    )

  return (
    <FlexGrid justify="flex-start" gutter={gutter || 0.3}>
      {!!left && icon}
      <Text inlineBlock color={color} {...props}>
        {label}
      </Text>
      {!left && icon}
    </FlexGrid>
  )
}

export default IconText
